module.exports = __webpack_public_path__ + "img/waterpurifier19.91ccf8e5.jpg";